import { useState } from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

import Button from './Button'
import { colours } from '../settings/settings'

const MyDialog = ({
  open = false,
  handleClose = () => {},
  triggerFunction = async () => handleClose(),
  triggerPath,
  title = 'Titolo',
  textUndo = 'Chiudi',
  textConfirm,
  textContent,
  maxWidth = 'sm',
  stretchWidth = false,
  stretchHeight = false,
  error = false,
  dialogLog,
  children,
}) => {
  const [loading, setLoading] = useState()

  const triggerFunctionAwait = async () => {
    setLoading(true)
    await triggerFunction()
    setLoading()
  }

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (!['backdropClick', 'escapeKeyDown'].includes(reason)) handleClose()
      }}
      fullWidth
      maxWidth={dialogLog ? 'lg' : maxWidth}
      slotProps={{
        backdrop: { sx: { backgroundColor: colours.backDrop } },
        paper: {
          style: {
            ...(stretchWidth && { minWidth: '95vw' }),
            ...(stretchHeight && { minHeight: '95vh' }),
          },
        },
      }}
      transitionDuration={{ enter: 250, exit: 0 }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {!!textContent && <DialogContentText>{textContent}</DialogContentText>}
        {!!dialogLog && <div dangerouslySetInnerHTML={{ __html: dialogLog }} />}
        {children}
      </DialogContent>
      <DialogActions>
        {!!textUndo && (
          <Button fitWidth transparent onClick={handleClose}>
            {textUndo}
          </Button>
        )}
        {!!textConfirm && (
          <Button
            {...(!!triggerPath ? { to: triggerPath } : {})}
            fitWidth
            error={error}
            loading={loading}
            onClick={triggerFunctionAwait}
            children={textConfirm}
          />
        )}
      </DialogActions>
    </Dialog>
  )
}

export default MyDialog
